/* =============================================================
   Ehub Predictive Search — shared engine
   ONE implementation powering the catalog hero AND the header
   search (desktop + mobile overlay). No per-context duplication.

   Public API:
     window.EhubPS.attach(input, panel, opts)
       opts = { variant, contactUrl, phoneUrl, searchUrl,
                minChars, alwaysOpen, closest }
     window.EhubPS.initAuto()  -> binds all [data-ehub-ps] wrappers

   Results markup is identical everywhere (.ehub-ps-list items);
   only the container chrome differs per context.
   ============================================================= */
(function () {
  if (window.EhubPS) { window.EhubPS.initAuto(); return; } // executed twice guard

  var SUGGEST = '/search/suggest.json';

  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Serve a small thumbnail instead of the full-size image (CLS/LCP).
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=96';
  }

  var Q_ICON = '<span class="ehub-ps-qicon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg></span>';
  var C_ICON = '<span class="ehub-ps-qicon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"></rect><rect x="14" y="3" width="7" height="7" rx="1"></rect><rect x="3" y="14" width="7" height="7" rx="1"></rect><rect x="14" y="14" width="7" height="7" rx="1"></rect></svg></span>';

  function attach(input, panel, opts) {
    if (!input || !panel) return;
    if (input.__ehubPS) return; // per-input guard
    input.__ehubPS = true;
    opts = opts || {};

    var minChars = opts.minChars || 2;
    var variant = opts.variant || 'hero';
    var alwaysOpen = !!opts.alwaysOpen;
    var searchUrl = opts.searchUrl || '/search';
    var contactUrl = opts.contactUrl || '/pages/contact';
    var phoneUrl = opts.phoneUrl || contactUrl;
    // Element whose "outside click" closes the panel (defaults to panel's wrap).
    var scope = opts.closest ? (input.closest(opts.closest) || panel.parentNode) : panel.parentNode;

    var timer, ctrl, items = [], active = -1, lastQ = '';

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    if (panel.id) input.setAttribute('aria-controls', panel.id);

    function show() {
      if (alwaysOpen) { panel.classList.add('is-open'); return; }
      panel.hidden = false;
      panel.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }
    function hide() {
      if (alwaysOpen) { return; }
      panel.hidden = true;
      panel.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      active = -1; items = [];
    }

    function searchFor(q) {
      var pieces = encodeURIComponent(q);
      return searchUrl + (searchUrl.indexOf('?') > -1 ? '&' : '?') + 'q=' + pieces + '&type=product&options[prefix]=last';
    }

    function render(q, res) {
      var products = res.products || [], queries = res.queries || [], colls = res.collections || [];
      var body = '';

      if (queries.length) {
        body += '<div class="ehub-ps-h">Suggestions</div>';
        queries.slice(0, 4).forEach(function (x) {
          body += '<a class="ehub-ps-item ehub-ps-q" role="option" href="' + esc(x.url) + '">' + Q_ICON +
            '<span class="ehub-ps-txt"><span class="ehub-ps-title">' + (x.styled_text || esc(x.text)) + '</span></span></a>';
        });
      }
      if (colls.length) {
        body += '<div class="ehub-ps-h">Categories</div>';
        colls.slice(0, 3).forEach(function (c) {
          body += '<a class="ehub-ps-item ehub-ps-cat" role="option" href="' + esc(c.url) + '">' + C_ICON +
            '<span class="ehub-ps-txt"><span class="ehub-ps-title">' + esc(c.title) + '</span></span></a>';
        });
      }
      if (products.length) {
        body += '<div class="ehub-ps-h">Products</div>';
        products.forEach(function (p) {
          var src = p.image || (p.featured_image && p.featured_image.url) || '';
          var img = src
            ? '<img class="ehub-ps-thumb" src="' + esc(thumb(src)) + '" alt="" width="44" height="44" loading="lazy">'
            : '<span class="ehub-ps-thumb"></span>';
          var sub = p.vendor ? '<span class="ehub-ps-sub">' + esc(p.vendor) + '</span>' : '';
          body += '<a class="ehub-ps-item ehub-ps-prod" role="option" href="' + esc(p.url) + '">' + img +
            '<span class="ehub-ps-txt"><span class="ehub-ps-title">' + esc(p.title) + '</span>' + sub + '</span></a>';
        });
      }

      if (!products.length && !queries.length && !colls.length) {
        // Zero-results recovery — never a dead end.
        body =
          '<div class="ehub-ps-empty">' +
            '<p class="ehub-ps-empty-h">No exact match found.</p>' +
            '<a class="ehub-ps-empty-link" href="' + esc(searchFor(q)) + '">Search all products for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>' +
            '<a class="ehub-ps-empty-link" href="' + esc(contactUrl) + '">Request sourcing help &rarr;</a>' +
            '<a class="ehub-ps-empty-link" href="' + esc(phoneUrl) + '">Talk to a specialist &rarr;</a>' +
          '</div>';
      } else {
        body += '<a class="ehub-ps-all" href="' + esc(searchFor(q)) + '">View all results for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
      }

      panel.innerHTML = '<div class="ehub-ps-list ehub-ps--' + variant + '">' + body + '</div>';
      items = Array.prototype.slice.call(panel.querySelectorAll('.ehub-ps-item, .ehub-ps-all, .ehub-ps-empty-link'));
      active = -1;
      show();
    }

    function suggest(q) {
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var url = SUGGEST + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (input.value.trim() === q) render(q, (d.resources && d.resources.results) || {}); })
        .catch(function () {});
    }

    function highlight() {
      items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
      if (items[active]) items[active].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      if (q.length < minChars) { if (!alwaysOpen) { hide(); } else { panel.innerHTML = ''; } return; }
      clearTimeout(timer);
      timer = setTimeout(function () { suggest(q); }, 170);
    });

    input.addEventListener('keydown', function (e) {
      if (!items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(active + 1, items.length - 1); highlight(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(active - 1, 0); highlight(); }
      else if (e.key === 'Enter') { if (active >= 0 && items[active]) { e.preventDefault(); window.location.href = items[active].getAttribute('href'); } }
      else if (e.key === 'Escape') { hide(); }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= minChars && panel.innerHTML) show();
    });

    if (!alwaysOpen && scope) {
      document.addEventListener('click', function (e) { if (!scope.contains(e.target)) hide(); });
    }
  }

  function initAuto() {
    var wraps = document.querySelectorAll('[data-ehub-ps]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.__ehubPSbound) return;
      wrap.__ehubPSbound = true;
      var input = wrap.querySelector('input[name="q"]');
      var panel = wrap.querySelector('[data-ehub-ps-panel]');
      attach(input, panel, {
        variant: wrap.getAttribute('data-ehub-ps-variant') || 'hero',
        contactUrl: wrap.getAttribute('data-ehub-ps-contact') || '/pages/contact',
        phoneUrl: wrap.getAttribute('data-ehub-ps-phone') || '',
        searchUrl: wrap.getAttribute('data-ehub-ps-search') || '/search',
        closest: '[data-ehub-ps]'
      });
    });
  }

  window.EhubPS = { attach: attach, initAuto: initAuto };

  if (document.readyState !== 'loading') initAuto();
  else document.addEventListener('DOMContentLoaded', initAuto);
  document.addEventListener('shopify:section:load', initAuto);
})();
